/**
 * ? @description : Bar Chart for Students Performances
 */

// Dependencies
import React, { Fragment, useState, useEffect, memo } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";

//Axios
import Axios from "../../../../axios/Axios";
import { useDispatch } from "react-redux";
import showSnackbar from "../../../redux/features/appSlice";
import axios from "axios";

// Register Chart Properties
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
);

function StudentPerformances() {

  const dispatch = useDispatch();
  const [studentPerformanceTitle, setStudentPerformanceTitle] = useState([]);
  const [studentPerformanceData, setStudentPerformanceData] = useState([]);

  useEffect(() => {
    const controller = axios.CancelToken.source();
    (async () => {
      try{
        const options = {
          method: "get",
          url: `/dashboard/studentsperformance`,
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };
  
        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
          );
        
        let performanceTitle = response.data.map(data => data.feeback_name);
        let performanceData = response.data.map(data => data.students_count);
        
        setStudentPerformanceTitle(performanceTitle);
        setStudentPerformanceData(performanceData);

      }catch(error){
        if(!axios.isCancel(error)){
          dispatch(
            showSnackbar({
              message: "Couldn't able to retrieve student performance graph",
              severity: "error",
            })
          )}
      }
    })()
     return () => {
      controller.cancel();
  }
  }, [dispatch])

  let data = {
    labels: studentPerformanceTitle,
    datasets: [
      {
        label: "Students Performances",
        data: studentPerformanceData,
        backgroundColor: ["rgba(19, 41, 112, 0.3)"],
        borderColor: ["rgba(19, 41, 112, 1)"],
        borderWidth: 2,
        borderRadius: 5
      },
    ],
  };

  let options = {
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    legend: {
      labels: {
        fontSize: 16,
      },
    },
  };

  const plugins = [
    {
      afterDraw: function (chart) {
        if (chart.data.datasets[0].data.length < 1) {
          let ctx = chart.ctx;
          let width = chart.width;
          let height = chart.height;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.font = "15px Arial";
          ctx.fillText("No data to display", width / 2, height / 2);
          ctx.restore();
        }
      },
    },
  ];

  return (
    <Fragment>
      <Bar height={300} data={data} options={options} plugins={plugins}/>
    </Fragment>
  );
}

export default memo(StudentPerformances);
